import { useState, useEffect, useCallback } from 'react';
import { dataProvider } from '../../../App';
import { GET_LIST } from 'react-admin';

export default function BuyerFetch(query) {
  const [buyers, setBuyers] = useState([]);
  const [error, setError] = useState(false);

  const getAllBuyers = useCallback(async () => {
    try {
      let allUsers = [];
      let page = 1;
      let totalFetched = 0;
      let pageSize = 100;

      while (true) {
        const { data, total } = await dataProvider(GET_LIST, 'users', {
          pagination: { page, perPage: pageSize },
          sort: { field: '_id', order: 'ASC' },
          filter: query || {}
        });

        allUsers = [...allUsers, ...data];
        totalFetched += data.length;

        if (totalFetched >= total || data.length === 0) break;
        page++;
      }

      // Filter only approved buyers
      const approvedBuyers = allUsers.filter(
        user => user.status === 'approved-buyer-seller' || user.status === 'approved-buyer'
      );

      // Map to { value, label } format for dropdown
      const newBuyers = approvedBuyers.map(user => ({
        value: user._id,
        label: `U${user.numericId} ${user.firstName} ${user.lastName}`
      }));

      setBuyers(newBuyers);
    } catch (err) {
      setError(err);
    }
  }, [query]);

  useEffect(() => {
    getAllBuyers();
  }, [getAllBuyers]);

  return { buyers, error };
}
